import styled from 'styled-components'
import { Body2 } from '~/styles/global'

export const Wrapper = styled.div``

export const MessageTextLine = styled(Body2)`
  margin-bottom: 20px;
`
